const TURBO_PAYMENT_WIDGET_PREFIX = "tur-pay-wid";

export const TURBO_PAYMENT_WIDGET_DATA_TEST_IDS = {
    MOVING_TRAY_CONTAINER: `${TURBO_PAYMENT_WIDGET_PREFIX}_mov_try_con`,
    MOVING_TRAY: `${TURBO_PAYMENT_WIDGET_PREFIX}_mov_try`,
    SHIMMER: `${TURBO_PAYMENT_WIDGET_PREFIX}_shim`,
    CHANGE_PAY_CTA: `${TURBO_PAYMENT_WIDGET_PREFIX}_chn_pay_cta`,
    CTA_TEXT: `${TURBO_PAYMENT_WIDGET_PREFIX}_cta_txt`,
    DISCOUNT_TEXT: `${TURBO_PAYMENT_WIDGET_PREFIX}_dis_txt`,
    EDU_COMMS: `${TURBO_PAYMENT_WIDGET_PREFIX}_edu_comms`,
    FK_COINS_ELIGIBLE_COMMS: `${TURBO_PAYMENT_WIDGET_PREFIX}_fk_coins_eligible_comms`,
    OFFER_COMMS: `${TURBO_PAYMENT_WIDGET_PREFIX}_offer_comms`,
    COMMS_CLOSE: `${TURBO_PAYMENT_WIDGET_PREFIX}_comms_cls`,
};

const TURBO_PAYMENT_METHOD_WIDGET_PREFIX = "tur-pay-method-wid";

export const TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS = {
    PAYMENT_ICON: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-payment-icon`,
    DISPLAY_NAME: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-display-name`,
    INLINE_BALANCE_CONTAINER: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-inline-balance-container`,
    SLIDER_BUTTON: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-slider-button`,
    CHANGE_CTA: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-change-cta`,
    DISCOUNT_TOOLTIP: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-discount-tooltip`,
    PAY_BUTTON: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-pay-button`,
    PAY_BUTTON_TEXT: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-pay-button-text`,
    PAY_BUTTON_BOLT: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-pay-button-bolt`,
    PAY_BUTTON_BOLT_TEXT: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-pay-button-bolt-text`,
    PAY_BUTTON_DISCOUNT: `${TURBO_PAYMENT_METHOD_WIDGET_PREFIX}-pay-button-discount`,
};

const TURBO_POD_HALF_CARD_PREFIX = "tur_pod_hc";

export const TURBO_POD_HALF_CARD_TEST_IDS = {
    TITLE: `${TURBO_POD_HALF_CARD_PREFIX}_title`,
    SUB_TITLE: `${TURBO_POD_HALF_CARD_PREFIX}_st`,
    PRIMARY_CTA: `${TURBO_POD_HALF_CARD_PREFIX}_primary_cta`,
    SECONDARY_CTA: `${TURBO_POD_HALF_CARD_PREFIX}_sec_cta`,
};
